// GENERATED FILE - DO NOT MODIFY

export enum GetBookingsSortColumnDto {
    AmenityName = "AmenityName",
    UserName = "UserName",
    CompanyName = "CompanyName",
    Date = "Date",
}